import '.bi{max-width:480px;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.cx{border-radius:24px;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.c1{padding:48px;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.cy{justify-content:center;}.ssr-plugin'
import '.b5{text-align:center;}.ssr-plugin'
import '.c2{overflow:hidden;}.ssr-plugin'
import '.bl{margin-bottom:16px;}.ssr-plugin'
import '.bn{margin-bottom:24px;}.ssr-plugin'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { Button } from './Button.js'
import { ModalWrapper, MODAL_PANEL_ANIMATION } from './ModalWrapper.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { useDictionary } from '../hooks/useDictionary.js'

export const AnnouncementModal = ({ setModal, announcement }) => {
  const dictionary = useDictionary()
  return (
    <ModalWrapper onDismiss={() => {}}>
      <div className="bi m cx ai c1 f e w cy b5 c2"
        style={{
          border: `1px solid ${colors.border}`,
          backgroundColor: `${transparentColor(colors.secondary, 0.9)}`,
          animation: MODAL_PANEL_ANIMATION,
        }}
      >
        <div className="ai">
          <h3 className="bl">Announcement</h3>
          <p className="bn">{announcement}</p>
          <Button
            onClick={() => {
              setModal(false)
            }}
            style={{ margin: '0 auto' }}
          >
            {dictionary.closeButton}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  )
}
